<div class="content-wrapper">
    <section class="content">
      <div class="box">
        <div class="box-body">
          <form [formGroup]="EmployeeRecoveryRecordsForm" (ngSubmit)="SearchJVRecord()">
            <div class="panel panel-default">
              <header class="panel-heading">
                <h5 class="panel-title">Send To Payroll For Recovery</h5>
              </header>
              <mat-card class="btnCard">
                    <!-- <button type="button" *ngIf="(_global.IsAdmin || _global.IsFinance) && ShowJV==true"
                        mat-stroked-button (click)="ConfirmationAlert();">Generate Journal Voucher</button>                    
                    <button type="button" mat-stroked-button (click)="_commonService.Exit()">Exit</button> -->
                    
                    <button type="button" *ngIf="(_global.IsAdmin || _global.IsFinance) && ShowJV==true"
                        mat-stroked-button (click)="ConfirmationAlert();">Send To Payroll For Recovery</button>                    
                    <button type="button" mat-stroked-button (click)="_commonService.Exit()">Exit</button>
                </mat-card>
              <div class="panel-body">                
                <div class="row">
                <div class="form-group col-md-6">
                    <label>Entity</label>
                    <p-dropdown [options]="FirmList" placeholder="--Select Entity Type--"
                    formControlName="entityid" filter="true">
                    </p-dropdown>
                </div>
                  <div class="form-group col-md-6">
                    <label>Reported Location</label>
                    <p-dropdown [options]="ReportedLocationList" placeholder="--Select Location--"
                    formControlName="ReportedLocationID" filter="true">
                    </p-dropdown>
                  </div>                 
                </div>                                      
              </div>
              <div class="panel-footer" style="text-align: right">
                <button mat-stroked-button type="submit">Get Result</button>
                <button mat-stroked-button type="button" (click)="Reset()">Reset</button>
                <!-- <button type="button" mat-stroked-button (click)="Export()">Export</button> -->
               
              </div>
            </div>
  
            <div class="tabel-loading-shade" *ngIf="isLoadingResults">
              <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
            </div>
            <div class="table-container">
              <table mat-table [dataSource]="LocationDataSource" style="width:99% !important">
                <!-- Position Column -->               
                <ng-container matColumnDef="chk">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox *ngIf="LocationDataSource" (change)="$event ? masterToggle($event) : null"
                                      [checked]="selection.hasValue() && isAllSelected()"
                                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                      (change)="$event ? selection.toggle() : null"
                                      [checked]="selection.isSelected(element)"
                                      (change)="$event ? selectRow($event, element) : null" >
                        </mat-checkbox>
                      </td>    
                </ng-container>             
                <ng-container matColumnDef="RecordID">
                  <th mat-header-cell *matHeaderCellDef> Record ID </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" style="color: dodgerblue"><a> <span  style="display:none">{{element.RequestEntityId}}</span> {{element.RecordID}}</a>
                  </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="UserName">
                  <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.UserName }} </td>
                </ng-container>
  
                <ng-container matColumnDef="UserEmail">
                  <th mat-header-cell *matHeaderCellDef> Employee Email </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.UserEmail}} </td>
                </ng-container>
  
                <ng-container matColumnDef="UserLocation">
                  <th mat-header-cell *matHeaderCellDef> Employee Location </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.UserLocation}} </td>
                </ng-container>
                <ng-container matColumnDef="ReportedLocation">
                  <th mat-header-cell *matHeaderCellDef> Reported Location </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.ReportedLocation}} </td>
                </ng-container>
                <ng-container matColumnDef="AssetType">
                  <th mat-header-cell *matHeaderCellDef> Asset Type </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.AssetType}} </td>
                </ng-container>
                <ng-container matColumnDef="PenaltyType">
                  <th mat-header-cell *matHeaderCellDef> Penalty Type </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.PenaltyType}} </td>
                </ng-container>
                <ng-container matColumnDef="PenaltyAmount">
                  <th mat-header-cell *matHeaderCellDef> Penalty Amount </th>
                  <td mat-cell *matCellDef="let element"  (click)="$event.stopPropagation()"> {{element.PenaltyAmount}} </td>
                </ng-container> 
                <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef> Status </th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"> {{element.Status}} </td>
                </ng-container>               
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor:pointer;"
                (click)="selection.toggle(row)">
                  ></tr>
                 
              </table>
            </div>
          </form>
          <mat-paginator [length]="_global.length" (page)="onPaginateChange($event)"></mat-paginator>
          <div style="float:right;">Page : <input type="text" numbersOnly style="width:50px;height:10px;"
              [(ngModel)]="_global.pageIndex" /> of {{_global.totalPage}} &nbsp;&nbsp;&nbsp;&nbsp;<button type="button"
              mat-stroked-button (click)="GoToPage()">Go</button></div>
        </div>
      </div>
    </section>
  </div>